/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { Component } from 'react'
import autoBind from 'auto-bind'

// lib
import isEqualProps from 'lib/isEqualProps'
import mapActionLog from 'lib/mapActionLog'
import proxyOverride from 'lib/proxyOverride'
import mapAsyncActions from 'lib/mapAsyncActions'

// react components & containers
import rcsTemplateListHoc from 'commonHoc/RcsTemplateListHoc'
import RcsTemplateList from 'components/organisms/RcsTemplateList'

/**
 * rcs template list
 */
class RcsTemplateListContainer extends Component {
  constructor(props) {
    super(props)
    // 해당 컨테이너 내의 메서드에 자동으로 this 클래스를 바인딩 합니다.
    autoBind(this)
    // 해당 컨테이너 내의 메서드 실행 시 액션로그를 남깁니다.
    mapActionLog(this)
    // HOC 사용 시 현재 컨테이너에 proxy가 props에 존재하는 경우 proxy 메서드에 this 클래스의 메서드를 대입
    proxyOverride(this)
    // 2차 인증을 사용하는 리덕스 액션이 존재하는 경우 덮어씌워 await이 정상적으로 작동하게 합니다.
    mapAsyncActions(this.props, {
      // exceptActions: { AppsActions: true }
    })
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    return (
      !isEqualProps(nextProps, this.props) ||
      !isEqualProps(nextState, this.state)
    )
  }

  render = () => {
    // hoc 사용 시 proxy 삭제하세요.
    return <RcsTemplateList {...this.props} />
  }
}

export default rcsTemplateListHoc(RcsTemplateListContainer)
